import { createModule, action, mutation } from 'vuex-class-component';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import { CreateActivityDto, FindActivitiesResponse } from '@/@types/Activity';

const VuexModule = createModule({
  namespaced: 'theoryApiActivitiesStore',
  strict: false,
});

export class ActivitiesStore extends VuexModule {
  private readonly activitiesRepository = RepositoryFactory.theoryApi.activitiesRepository();
  /** state */
  private organizationActivities: FindActivitiesResponse | null = null;
  private projectActivities: FindActivitiesResponse | null = null;

  @mutation
  private setOrganizationActivities(payload: FindActivitiesResponse | null) {
    this.organizationActivities = payload;
  }

  @mutation
  private setProjectActivities(payload: FindActivitiesResponse | null) {
    this.projectActivities = payload;
  }

  @action
  async fetchOrganizationActivities(params: { projectIds: number[], organizationId: number}) {
    const results = await this.activitiesRepository.fetchActivitiesByProjectIds(
      params.projectIds,
      params.organizationId,
    );
    this.setOrganizationActivities(results);
  }

  @action
  async fetchProjectActivities(params: { projectIds: number[], organizationId: number}) {
    const results = await this.activitiesRepository.fetchActivitiesByProjectIds(
      params.projectIds,
      params.organizationId,
    );
    this.setProjectActivities(results);
  }

  @action
  async createActivity(params: CreateActivityDto) {
    await this.activitiesRepository.createActivity(params);
  }

  @action
  async deleteOrganizationActivities() {
    this.setOrganizationActivities(null);
  }

  @action
  async deleteProjectActivities() {
    this.setProjectActivities(null);
  }

  get getOrganizationActivities() {
    return this.organizationActivities;
  }

  get getProjectActivities() {
    return this.projectActivities;
  }
}
